import { Box, Typography } from '@material-ui/core';
import { useBaseStore, useUserStore } from '@roc/feature-app-core';
import { useAppraisalReviewStore } from '@roc/feature-appraisals';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { Document } from '@roc/feature-types';
import { StandardDialog } from '@roc/ui';
import { AppraisalReviewReportForm, EditableToogleButton } from 'libs/feature-appraisals/src/appraisals/appraisalReview/appraisalReviewForm';
import { ManualOrAutomatedChip } from 'libs/feature-appraisals/src/appraisals/appraisalReview/manualOrAutomatedChip';
import { observer } from 'mobx-react';

type Props = {
  open: boolean;
  onClose: () => void;
  document: Document;
};

export const AppraisalReviewReportDialog = observer(
  ({ open, onClose, document }: Props) => {
    const { globalStore } = useBaseStore();
    const { userStore } = useUserStore();
    const taskId = document?.taskId;

    const { appraisalReviewStore } = useAppraisalReviewStore();

    const dialogContent = (hideTitle = true, sendDocument = false) => (
      <AppraisalReviewReportForm
        store={appraisalReviewStore}
        loanId={document?.loanId}
        propertyId={document?.collateralId}
        onClose={onClose}
        hideTitle={hideTitle}
        successCallback={() => {
          globalStore.notificationStore.showSuccessNotification({
            message: 'Data saved successfully.',
          });
          onClose();
        }}
        document={sendDocument ? document : null}
      />
    );

    const getTitle = () => {
      return (<>
        <Typography variant='h5'>
          Appraisal Review Report{' '}
        </Typography>
        <ManualOrAutomatedChip
          status={appraisalReviewStore.manualAutomatedStatus}
        />
        {userStore.canEditAppraisalReportConfig() && (
          <EditableToogleButton
            checked={appraisalReviewStore.editEnabled}
            label="Editable"
            onClick={() => { appraisalReviewStore.updateReportEditableFlag(document?.loanId, document?.collateralId) }}
          />
        )}
      </>);
    }

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            maxWidth={'lg'}
            open={open}
            title={'Appraisal Review Report'}
            handleClose={onClose}
            dialogContent={<Box>
              {dialogContent(false, true)}
            </Box>}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            maxWidth={'lg'}
            open={open}
            title={getTitle()}
            handleClose={onClose}
            dialogContent={dialogContent(true)}
            removeContentBox
          />
        )}
      </>
    );
  }
);
